import { useContext } from 'react';

import { ExamEventSessionDetailsContext } from './exam-event-session-details-provider';

function useExamEventSessionDetails() {
  const context = useContext(ExamEventSessionDetailsContext);
  if (!context) {
    throw new Error(
      'useExamEventSessionDetails must be used within an ExamEventSessionDetailsProvider',
    );
  }
  return context;
}

export { useExamEventSessionDetails };
